import React from 'react';
import PropTypes from 'prop-types';

const BlankSpacePlaceholder = ({
    img,
    title,
    description,
    actions,
    className,
    classNameTitle,
    centerSuffix
}) => {
    return (
        <div
            data-testid="blank-space-placeholder"
            className={`blank-space-placeholder ${className || 'standard'}`}
        >
            <div className={`center-${centerSuffix ?? 'vertically'}`}>
                <div className="image-icon-wrapper">{img}</div>
                {title && (
                    <h2
                        className={`main-title ${
                            classNameTitle || 'standard'
                        }`}
                    >
                        {title}
                    </h2>
                )}
                {description && (
                    <h5 className="main-description">
                        {description}
                    </h5>
                )}
                {actions}
            </div>
        </div>
    );
};

BlankSpacePlaceholder.propTypes = {
    className: PropTypes.string,
    classNameTitle: PropTypes.string,
    centerSuffix: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    description: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    // 𝘤𝘰𝘯𝘵𝘦𝘯𝘵 𝘱𝘭𝘢𝘤𝘦𝘥 𝘢𝘧𝘵𝘦𝘳 𝘥𝘦𝘴𝘤𝘳𝘪𝘱𝘵𝘪𝘰𝘯
    actions: PropTypes.element,
    // 𝘴𝘪𝘯𝘨𝘭𝘦 𝘪𝘮𝘢𝘨𝘦 𝘰𝘳 𝘤𝘰𝘮𝘱𝘰𝘯𝘦𝘯𝘵 𝘵𝘩𝘢𝘵 𝘪𝘯𝘤𝘭𝘶𝘥𝘦𝘴 𝘮𝘰𝘳𝘦 𝘪𝘮𝘢𝘨𝘦𝘴
    img: PropTypes.object.isRequired
};

export default BlankSpacePlaceholder;
